var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardFluidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#A8DEF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2062 13.6582C31.0896 13.5293 30.9252 13.4557 30.7509 13.4557H17.2509C17.0778 13.4557 16.9122 13.5293 16.7956 13.6582C16.6802 13.7858 16.6225 13.9576 16.6397 14.1307L18.4806 32.5398C18.5125 32.854 18.7764 33.0921 19.0918 33.0921H28.91C29.2254 33.0921 29.4892 32.854 29.5199 32.5398L31.3608 14.1307C31.3792 13.9576 31.3228 13.7858 31.2062 13.6582ZM30.0722 14.683L29.5727 19.6878C28.0128 20.1922 25.9829 20.4254 24.3899 19.1183C22.3932 17.4799 19.946 17.7622 18.2867 18.2556L17.9296 14.683H30.0722Z",
    fill: "#103A5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardFluidIcon);
export default __webpack_public_path__ + "static/media/card-fluid-icon.245bedf06eddae5448403034cc85716c.svg";
export { ForwardRef as ReactComponent };